export function commaFormatCurrency(
  input: number | null | undefined,
  hideDecimals?: boolean
) {
  // TODO: Fix to force a standardized number of decimal places (10.10 is converted to 10.1) -- NOH 9/25/23
  input = hideDecimals ? Math.floor(input ?? 0) : input;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
  return formatter.format(input || 0);
}
